interface Props {
  label: string;
  /** Use the muted treatment for "+3 more" overflow indicators. */
  muted?: boolean;
}

/**
 * Compact, non-interactive tag chip for the blog row. Visual language
 * matches the editor's TagInput (tide tint + paper-style background)
 * so a tag looks the same wherever it appears in the product.
 */
export function TagChip({ label, muted }: Props) {
  return (
    <span
      className={`hair inline-flex items-center rounded-sm border px-1.5 py-[1px] text-[10.5px] font-medium leading-tight ${
        muted
          ? "border-transparent bg-canvas-2/70 text-ink-4"
          : "border-tide/15 bg-tide-ss/70 text-tide"
      }`}
    >
      {label}
    </span>
  );
}
